export default "__VITE_ASSET__0fbb9fd8__"